module.exports = __webpack_public_path__ + "static/media/ticket.b07be3ee.mp3";